import { UseAuthorizeProps } from 'hooks/useAuthorize'
import { CampaignPermissionType, FeatureName } from 'types/features'
import { BaseRole } from 'types/user'

/**
 * Mirrors the backend `ApplicationPolicy#admin_or_edit_discount?`, which gates
 * `DispositionPolicy#{list?, manage_correction?}`. `allowedFor` ANDs `template` and `feature`,
 * so "admin OR edit_discount" has to be expressed as two separate calls.
 */
export const canManageDispositions = (allowedFor: UseAuthorizeProps['allowedFor']): boolean =>
  allowedFor({
    feature: { name: FeatureName.Campaigns, action: CampaignPermissionType.EditDiscount },
  }) || allowedFor({ template: { roles: [BaseRole.ADMIN] } })
